export default __webpack_public_path__ + "media/images/logo-symbol-icon-de9e68dc49b19eb5cd142d3316f9e95e.svg";